class C_Entity
{
    constructor()
    {
        this.FLIER = 1;
        this.WEAPON_PROJECTILE = 2;
        this.SPAWNER = 3;
        this.ASTEROID = 4;
        this.ASTEROID_SPAWNER = 5;
        this.ENEMY_PROJECTILE = 6;
        this.MOON = 7;
        this.FRIENDLY_BOT = 8;
        this.BOT_SPAWN_CONTROLLER = 9;
        this.EXPOLOSION = 10;
        this.FORMATION_SPAWNER = 11;
    }

}

export default (new C_Entity);